import { render, staticRenderFns } from "./Qqwallet.vue?vue&type=template&id=40068d92&"
import script from "./Qqwallet.vue?vue&type=script&lang=js&"
export * from "./Qqwallet.vue?vue&type=script&lang=js&"
import style0 from "./Qqwallet.vue?vue&type=style&index=0&id=40068d92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports